import React from "react";
import Header from "../../../../Components/Header";
import Deliverynote from "./Deliverynote";
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";

const ViewDeliverynote = () => {
  const location = useLocation();

  const deliveryNoteId = location.state?.delivery_note_id;
    const picklist_id = location.state?.picklist_id;

  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
       <Helmet>
				<title>Delivery Note - View</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{flexGrow:'1'}}>
        <Deliverynote deliveryNoteId={deliveryNoteId} />
      </div>
  </div>
  );
};

export default ViewDeliverynote;
